export default __webpack_public_path__ + "static/media/LP-L-NG.6f178988.jpg";